import { localStorage } from './browserStorage';

// JSON compatibility for existing local-storage consumers, without its unsafe
// module-level window.localStorage access.
export function get<T = any>(key: string): T {
    const value = localStorage.getItem(key);
    try { return JSON.parse(value as any); } catch (_) { return value as any; }
}
export function set<T = any>(key: string, value: T): boolean {
    try { localStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (_) { return false; }
}
export const remove = (key: string): void => localStorage.removeItem(key);
export const clear = (): void => localStorage.clear();
